import { createRenderTarget } from 'component-library/render-target'
import { RssTextLink } from 'component-library/typography/TextLink/TextLink.rss'
import { WebTextLink } from 'component-library/typography/TextLink/TextLink.web'
import { LinkClickedEvent } from 'common/events/component-events'

export interface TextLinkProps {
    href: string
    className?: string
    dataLinkType?: string
    openInNewWindow?: boolean

    // HTMl Microdata
    itemScope?: boolean
    itemType?: string

    onEvent?: (event: LinkClickedEvent) => void
}

export const TextLink = createRenderTarget<TextLinkProps>('TextLink', {
    amp: WebTextLink,
    web: WebTextLink,
    rss: RssTextLink,
    preview: WebTextLink,
})
